import React, { forwardRef } from 'react';
import { BaseButton } from '../BaseButton';
import { IconButtonProps } from './IconButton.types';
import { ICON_BUTTON_SIZES } from './IconButton.constants';

export const IconButton = forwardRef<HTMLButtonElement | HTMLAnchorElement, IconButtonProps>(
    ({ size = 'md', shape = 'circle', children, ...rest }, ref) => (
        <BaseButton
            ref={ref}
            borderRadius={shape === 'square' ? 'xl' : 'circle'}
            {...ICON_BUTTON_SIZES[size]}
            {...rest}
        >
            {children}
        </BaseButton>
    )
);

IconButton.displayName = 'IconButton';
